import { useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import { getFolderTree } from "../api/folders.api";
import type { FolderTreeNode } from "../types/project-storage.types";
import { mapStorageError } from "../utils/storageErrors";

export const folderTreeQueryKey = (mmCode: number) =>
  ["storage-tree", mmCode] as const;

export function useFolderTree(mmCode: number | null) {
  const queryClient = useQueryClient();

  return useQuery<FolderTreeNode[]>({
    queryKey: folderTreeQueryKey(mmCode ?? 0),
    queryFn: () => getFolderTree(mmCode as number),
    enabled: mmCode !== null,
    staleTime: 30_000,
    onError: (error: unknown) => {
      const mapped = mapStorageError(error, "navigation");
      if (mapped.errorCode === "PROJECT_NOT_FOUND") {
        toast.error(mapped.message);
        return;
      }
      toast.error(mapped.message);
    },
    meta: {
      invalidateTree: () => {
        if (mmCode !== null) {
          queryClient.invalidateQueries(folderTreeQueryKey(mmCode));
        }
      },
    },
  });
}
